import {Card, Col, Row} from "react-bootstrap";
import {ProjectColors} from "../../../Enums/Core/projectColors";
import React from "react";

export default function TotalSitesAndSystems(props) {
    const totalSites = props.data.entities.sites;
    const totalSystems = props.data.entities.waterSystems;

    const titleStyle = {fontWeight: 'bold'};
    const valueStyle = {fontWeight: 'bold', textAlign: 'left', fontSize: 'x-large', color: ProjectColors.Aqua};

    return (
        <Card style={{height: '272px'}}>
            <Card.Body>
                <Card.Title style={titleStyle}>Sites</Card.Title>
                <Row style={{marginTop: '40px', paddingBottom: '16px'}}>
                    <Col>
                        <Card.Text style={valueStyle}>
                            {totalSites.toLocaleString()}
                        </Card.Text>
                    </Col>
                </Row>
                <hr/>
                <Card.Title style={titleStyle}>Systems</Card.Title>
                <Row style={{paddingBottom: '13px'}}>
                    <Col>
                        <Card.Text style={valueStyle}>
                            {totalSystems.toLocaleString()}
                        </Card.Text>
                    </Col>
                </Row>
            </Card.Body>
        </Card>
    )
}